import React, { useRef, useState, useEffect } from 'react'
import useBoxPreview from './useBoxPreview'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'

import './styles.css.scss'

const BOX_VIEWER_CLASS = 'box-preview-container'

const BoxViewer = ({ previewMetadata }) => {
  const [loaded, setLoaded] = useBoxPreview()
  const id = useRef(uniqueId('box-id-'))
  const preview = useRef()

  const initBoxPreview = () => new global.Box.Preview()

  const disposeBoxPreviewLibrary = () => {
    if (preview.current) {
      preview.current.destroy()
      preview.current.removeAllListeners()
      preview.current = undefined
    }
  }

  useEffect(() => {
    if (loaded) {
      preview.current = initBoxPreview()
      try {
        preview.current.show(previewMetadata.file_id, previewMetadata.access_token, {
          container: `#${id.current}`,
          showDownload: false,
          header: 'none'
        })
      } catch {
        return null
      }
    }
    return () => {
      disposeBoxPreviewLibrary()
    }
  }, [loaded])

  return <div id={id.current} className={BOX_VIEWER_CLASS} />
}

BoxViewer.propTypes = {
  previewMetadata: PropTypes.object.isRequired
}

export default React.memo(BoxViewer)
